module.exports = __webpack_public_path__ + "static/media/cup.32faddb4.png";